import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import PaletteIcon from '@mui/icons-material/Palette';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TemplateThumbnail from './TemplateThumbnail';
import { templatePickerCardSx } from '../Common/formStyles';

const LAYOUT_LABELS = {
  'single-column': 'Single column',
  'two-column': 'Sidebar',
  timeline: 'Timeline',
  split: 'Split',
  compact: 'Compact',
};

/**
 * Opens the template gallery — shows a mini resume preview when template data is available.
 */
const TemplatePickerButton = ({
  template,
  templateId,
  templates = [],
  onClick,
  disabled = false,
  compact = false,
  label = 'Template',
}) => {
  const selected = template || templates.find((t) => t.id === templateId);
  const displayName =
    selected?.name ||
    (templateId
      ? templateId.split('-').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
      : 'Choose template');

  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      disabled={disabled}
      sx={[
        templatePickerCardSx,
        {
          border: 'none',
          font: 'inherit',
          opacity: disabled ? 0.55 : 1,
          pointerEvents: disabled ? 'none' : 'auto',
        },
      ]}
    >
      {selected ? (
        <TemplateThumbnail template={selected} compact />
      ) : (
        <Box
          sx={{
            width: 48,
            height: 60,
            flexShrink: 0,
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: (t) =>
              t.palette.mode === 'dark' ? 'rgba(129,140,248,0.12)' : 'rgba(99,102,241,0.08)',
          }}
        >
          <PaletteIcon color="primary" fontSize="small" />
        </Box>
      )}

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: 'block', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', fontSize: '0.62rem', mb: 0.25 }}
        >
          {label}
        </Typography>
        <Typography variant="body2" fontWeight={700} color="text.primary" noWrap>
          {displayName}
        </Typography>
        {!compact && selected?.layout && (
          <Chip
            label={LAYOUT_LABELS[selected.layout] || selected.layout}
            size="small"
            sx={{
              mt: 0.5,
              height: 18,
              fontSize: '0.62rem',
              fontWeight: 600,
              bgcolor: (t) =>
                t.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(15,23,42,0.05)',
            }}
          />
        )}
      </Box>

      <ChevronRightIcon sx={{ color: 'text.secondary', fontSize: 20, flexShrink: 0 }} />
    </Box>
  );
};

export default TemplatePickerButton;
